import { createAction } from 'typesafe-actions';
import { IValueAddedTax } from '../../../@types/model/masterData/valueAddedTax/valueAddedTax';

export default class MasterDataValueAddedTaxActions {
    public static readonly set = createAction('MASTER_DATA_SET_VALUE_ADDED_TAX', resolve => (valueAddedTax : Array<IValueAddedTax>) => resolve(valueAddedTax));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPS_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}